var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"height":"200","type":"pie","options":_vm.options,"series":_vm.usageDataEntries.map(entry => entry.sales_volume)}})
}
var staticRenderFns = []

export { render, staticRenderFns }